import httpClient, { handleSuccess, handleError, apiHeader } from './httpClient'
import dayjs from 'dayjs'

export function list() {
  return httpClient.get('announcement/list').then(handleSuccess).catch(handleError)
}

export function listReaction(announcementId) {
  const params = new URLSearchParams()
  params.append('announcement_id', announcementId)

  return httpClient
    .get('announcement/list_reaction', {
      params
    })
    .then(handleSuccess)
    .catch(handleError)
}

export function listProgramTimeAndCourse() {
  return httpClient.get('announcement/list_program_time_and_course').then(handleSuccess).catch(handleError)
}

export function listPrefecture() {
  return httpClient.get('announcement/list_prefecture').then(handleSuccess).catch(handleError)
}

export async function listToUser(search) {
  // 検索条件がうまく動かない
  const params = new URLSearchParams()
  if (search.text) {
    params.append('name', search.text)
  }
  if (search.select.address_prefecture.length) {
    params.append('address_ids', search.select.address_prefecture.join())
  }
  if (search.select.tag.length) {
    params.append('tag_ids', search.select.tag.join())
  }
  if (search.select.program_time.length) {
    params.append('program_time_ids', search.select.program_time.join())
  }
  return httpClient.get('announcement/list_to_user', { params }).then(handleSuccess).catch(handleError)
}

export function listUserTags() {
  return httpClient.get('announcement/list_user_tag').then(handleSuccess).catch(handleError)
}

export async function info(announcementId) {
  const params = new URLSearchParams()
  params.append('announcement_id', announcementId)

  return httpClient
    .get('announcement/info', {
      params
    })
    .then(handleSuccess)
    .catch(handleError)
}

export async function _delete(announcementId) {
  const params = new URLSearchParams()
  params.append('announcement_id', announcementId)

  return httpClient.post('announcement/delete', params, apiHeader).then(handleSuccess).catch(handleError)
}

export async function reply(announcementId, reply = 0, comment = '') {
  const params = new URLSearchParams()
  params.append('announcement_id', announcementId)
  params.append('reply', reply)
  params.append('comment', comment)

  return httpClient.post('announcement/reply', params, apiHeader).then(handleSuccess).catch(handleError)
}

export async function favorite(announcementId, toBeFavorite = 1) {
  const params = new URLSearchParams()
  params.append('announcement_id', announcementId)
  params.append('is_favorite', toBeFavorite)

  return httpClient.post('announcement/favorite', params, apiHeader).then(handleSuccess).catch(handleError)
}

export async function open(announcementId) {
  const params = new URLSearchParams()
  params.append('announcement_id', announcementId)

  return httpClient.post('announcement/open', params, apiHeader).then(handleSuccess).catch(handleError)
}

export async function save(formData) {
  const params = new URLSearchParams()
  params.append('to_user_ids', formData.to_user_ids)
  if (formData.announcement_id) {
    params.append('announcement_id', Number(formData.announcement_id))
  }
  params.append('title', String(formData.title))
  params.append('body', String(formData.body))
  params.append('is_draft', formData.is_draft)
  if (formData.reply_option_1) {
    params.append('reply_option_1', formData.reply_option_1)
  }
  if (formData.reply_option_2) {
    params.append('reply_option_2', formData.reply_option_2)
  }
  if (formData.reply_option_3) {
    params.append('reply_option_3', formData.reply_option_3)
  }
  if (formData.reply_option_4) {
    params.append('reply_option_4', formData.reply_option_4)
  }
  if (formData.reply_option_5) {
    params.append('reply_option_5', formData.reply_option_5)
  }

  if (formData.started_at) {
    params.append('started_at', dayjs(formData.started_at).format('YYYY/MM/DD'))
  }
  if (formData.ended_at) {
    params.append('ended_at', dayjs(formData.ended_at).format('YYYY/MM/DD'))
  }

  return httpClient.post('announcement/save', params, apiHeader).then(handleSuccess).catch(handleError)
}
